import { authProviders } from '@cx-web/repub-config';

export const events = {
  ACCOUNT_CREATED: 'account_created',
  ACCOUNT_CREATED_ATTEMPT: 'account_created_attempt',
  ACCOUNT_CREATED_ERROR: 'account_created_error',
  LOG_IN: 'login_complete',
  LOG_IN_ATTEMPT: 'login_attempt',
  LOG_IN_ERROR: 'login_error',
  LOG_OUT: 'logout_complete',
  SOCIAL_ATTEMPT: 'sso_attempt',
} as const;

export type Event = (typeof events)[keyof typeof events];

export const actions = {
  LOGIN: 'Submit Normal Login',
  LOGIN_ERROR: 'Login Error',
  LOGIN_SUCCESS: 'Login Success',
  LOGOUT_SUCCESS: 'Logout Success',
  SIGN_UP: 'Submit Normal Sign Up',
  SIGN_UP_ERROR: 'Account Created Error',
  SIGN_UP_SUCCESS: 'Account Created',
  SOCIAL_AUTH: 'Social Authentication',
} as const;

export type Action = (typeof actions)[keyof typeof actions];

export const views = {
  LOGIN: 'Login View',
  LOGOUT: 'Logout View',
  RESET_PASSWORD: 'Reset Password View',
  SIGN_UP: 'Sign Up View',
  SOCIAL_AUTH: 'Social Auth View',
} as const;

export type View = (typeof views)[keyof typeof views];

export const providers = {
  GOOGLE: 'google',
} as const;

export type OAuth2Provider = (typeof providers)[keyof typeof providers];

export { authProviders };

export function isView(view: string): view is keyof typeof views {
  return view in views;
}

export function isAuthProvider(provider: string): provider is keyof typeof authProviders {
  return provider in authProviders;
}
